import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Card, CardContent } from "@/components/ui/card";
import { Plus, Trash2, UserCog } from "lucide-react";
import { toast } from "sonner";

export default function Staff() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ name: "", email: "", password: "" });

    async function load() {
        const { data } = await api.get("/staff");
        setItems(data);
    }
    useEffect(() => {
        load();
    }, []);

    async function submit(e) {
        e.preventDefault();
        try {
            await api.post("/staff", form);
            toast.success("Personel eklendi");
            setOpen(false);
            setForm({ name: "", email: "", password: "" });
            load();
        } catch (err) {
            toast.error(formatApiError(err));
        }
    }
    async function del(id) {
        await api.delete(`/staff/${id}`);
        load();
    }

    return (
        <div data-testid="staff-page">
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h1 className="text-3xl font-bold text-slate-900">
                        Klinik Personeli
                    </h1>
                    <p className="text-slate-600 mt-1">
                        Personel hesapları oluşturun ve yönetin
                    </p>
                </div>
                <Dialog open={open} onOpenChange={setOpen}>
                    <DialogTrigger asChild>
                        <Button
                            className="dk-btn-primary rounded-full"
                            data-testid="add-staff-btn"
                        >
                            <Plus className="w-4 h-4 mr-1" /> Yeni Personel
                        </Button>
                    </DialogTrigger>
                    <DialogContent>
                        <DialogHeader>
                            <DialogTitle>Yeni Personel Hesabı</DialogTitle>
                        </DialogHeader>
                        <form onSubmit={submit} className="space-y-3">
                            <div>
                                <Label>Ad Soyad</Label>
                                <Input
                                    required
                                    value={form.name}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            name: e.target.value,
                                        })
                                    }
                                    data-testid="staff-name-input"
                                />
                            </div>
                            <div>
                                <Label>Kullanıcı Adı</Label>
                                <Input
                                    required
                                    type="text"
                                    value={form.email}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            email: e.target.value,
                                        })
                                    }
                                    data-testid="staff-email-input"
                                />
                            </div>
                            <div>
                                <Label>Şifre</Label>
                                <Input
                                    required
                                    type="text"
                                    value={form.password}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            password: e.target.value,
                                        })
                                    }
                                    data-testid="staff-password-input"
                                />
                            </div>
                            <Button
                                type="submit"
                                className="dk-btn-primary w-full"
                                data-testid="staff-submit-btn"
                            >
                                Ekle
                            </Button>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>

            <Card>
                <CardContent className="p-0">
                    <table className="w-full">
                        <thead>
                            <tr className="border-b bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-600">
                                <th className="px-6 py-3">Ad</th>
                                <th className="px-6 py-3">Kullanıcı Adı</th>
                                <th className="px-6 py-3">Eklendi</th>
                                <th className="px-6 py-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((s) => (
                                <tr
                                    key={s.id}
                                    className="border-b hover:bg-slate-50"
                                >
                                    <td className="px-6 py-4 font-medium flex items-center gap-2">
                                        <UserCog className="w-4 h-4 text-teal-600" />
                                        {s.name}
                                    </td>
                                    <td className="px-6 py-4 text-slate-700">
                                        {s.email}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-slate-500">
                                        {s.created_at?.slice(0, 10)}
                                    </td>
                                    <td className="px-6 py-4 text-right">
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            onClick={() => del(s.id)}
                                        >
                                            <Trash2 className="w-4 h-4 text-slate-400" />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            {items.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={4}
                                        className="text-center text-slate-500 py-12"
                                    >
                                        Henüz personel yok.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </CardContent>
            </Card>
        </div>
    );
}
